import React from 'react';
import { Download } from 'lucide-react';
import '../css/download.css';
import feature1 from './feature1.png';
import feature2 from './feature2.png';
import feature3 from './feature3.png';

export default function DownloadPage() {
    return (
        <div className="download-page">
            {/* Header Section */}
            <div className="header">
                <h1>野离子表单</h1>
                <p>随手记一记，生意有底气</p>
                <div className="button-group">
                    <a
                        href="https://apps.apple.com/cn/app/id6740758231"
                        className="download-button"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Download size={16} className="icon" /> 苹果下载
                    </a>
                    <a
                        href="https://file.market.xiaomi.com/download/AppStore/0663d3cea32ca4d27ac81aff4267a1db7e9083612/com.yeiontable_1.4.1.apk"
                        className="download-button"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Download size={16} className="icon" /> 安卓下载
                    </a>
                    <a
                        href="https://play.google.com/store/apps/details?id=com.yeiontable"
                        className="download-button"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Download size={16} className="icon" /> Google Play
                    </a>
                </div>
            </div>

            {/* Features Section (不变) */}
            <div className="features">
                <h2>核心功能</h2>
                <div className="feature-grid">
                    {[
                        {
                            title: '记账、自动计算利润统计',
                            description:
                                '轻松记账，自动计算利润，帮你实时掌握财务状况，省时又省心。',
                        },
                        {
                            title: '开单、生成PDF表格',
                            description:
                                '快速创建专业订单并一键导出为PDF表格，简化开单流程，提升客户信任与业务效率。',
                        },
                    ].map((feature, index) => (
                        <div key={index} className="feature-card">
                            <h3>{feature.title}</h3>
                            <p>{feature.description}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Screenshots Section (不变) */}
            <div className="screenshots">
                <h2>功能展示</h2>
                <div className="screenshot-grid">
                    {[
                        {
                            src: feature1,
                            alt: '功能 1',
                            desc: '打印、留底、分享，方便快捷',
                        },
                        {
                            src: feature2,
                            alt: '功能 2',
                            desc: '超多模板，人工客服辅助创建自定义模板',
                        },
                        {
                            src: feature3,
                            alt: '功能 3',
                            desc: '数据一目了然，支持自动计算统计订单',
                        },
                    ].map((item, index) => (
                        <div key={index} className="screenshot-card">
                            <img src={item.src} alt={item.alt} className="screenshot-img" />
                            <p>{item.desc}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Testimonials Section (不变) */}
            <div className="testimonials">
                <h2>典型用户说</h2>
                <div className="testimonial-grid">
                    {[
                        '帮我高效记账，超方便！',
                        '告别手写收据和账本，太适合做批发生意了',
                        '随时随地都能开单，真是太方便了',
                    ].map((quote, i) => (
                        <div key={i} className="testimonial-card">
                            <p>“{quote}”</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Footer CTA */}
            <div className="footer">
                <h3>立即下载体验</h3>
                <div className="button-group">
                    <a
                        href="https://apps.apple.com/cn/app/id6740758231"
                        className="download-button"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Download size={16} className="icon" /> App Store
                    </a>
                    <a
                        href="https://play.google.com/store/apps/details?id=com.yeiontable"
                        className="download-button"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Download size={16} className="icon" /> Google Play
                    </a>
                    <a
                        href="https://file.market.xiaomi.com/download/AppStore/0663d3cea32ca4d27ac81aff4267a1db7e9083612/com.yeiontable_1.2.4.apk"
                        className="download-button"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Download size={16} className="icon" /> Android下载
                    </a>
                </div>
                <p>
                    © 2025 广州野离子网络科技有限公司 |{' '}
                    <a href="./privacyios" className="privacy-link">
                        隐私政策
                    </a>
                </p>
            </div>
        </div>
    );
}